import { serializeArray } from '../components/utilities';

const B2B = {

  //////////////////////////
  // FORMS DISPLAY UPDATE //
  //////////////////////////
  toggleChange: function () {
    const
      boxLogin = document.querySelector('[data-b2b-access-login]'),
      boxRegister = document.querySelector('[data-b2b-access-register]')
    if (boxLogin && boxRegister) {
      let
        btnLogin = boxLogin.querySelector('[data-b2b-access-change]'),
        btnRegister = boxRegister.querySelector('[data-b2b-access-change]')
      if (btnLogin && btnRegister) {

        btnLogin.addEventListener('click', () => {
          boxLogin.classList.remove('-active');
          boxRegister.classList.add('-active');
        });
        btnRegister.addEventListener('click', () => {
          boxRegister.classList.remove('-active');
          boxLogin.classList.add('-active');
        });
      }
    }
  },
  toggleRecover: function () {
    const
      boxLogin = document.querySelector('[data-b2b-access-login]'),
      boxRecover = document.querySelector('[data-b2b-access-recover]')
    if (boxLogin && boxRecover) {
      let
        btnLogin = boxLogin.querySelector('[data-b2b-access-anchor]'),
        btnRecover = boxRecover.querySelector('[data-b2b-access-anchor]')
      if (btnLogin && btnRecover) {

        btnLogin.addEventListener('click', (e) => {
          e.preventDefault();
          boxLogin.classList.remove('-active');
          boxRecover.classList.add('-active');
        });
        btnRecover.addEventListener('click', (e) => {
          e.preventDefault();
          boxRecover.classList.remove('-active');
          boxLogin.classList.add('-active');
        });
      }
    }
  },

  /////////////////////////////
  // FORMS FIELDS VALIDATION //
  /////////////////////////////
  validateLogin: function (form) {
    let errorsTxt = [];

    if (form.querySelector('[name="email"]').value == '') errorsTxt.push('Informe seu email!');
    if (form.querySelector('[name="password"]').value == '') errorsTxt.push('Informe sua senha!');

    if (errorsTxt.length)
      B2B.showErrors(form);

    return { validated: !errorsTxt.length, errors: errorsTxt };
  },
  validateRegister: function (form) {
    let errorsTxt = [];

    if (form.querySelector('[name="terms"]') && form.querySelector('[name="terms"]').checked == false) errorsTxt.push('Aceite os termos de uso!');
    if (form.querySelector('[name="first_name"]').value == '') errorsTxt.push('Informe seu nome!');
    if (form.querySelector('[name="last_name"]').value == '') errorsTxt.push('Informe seu sobrenome!');
    if (form.querySelector('[name="phone_sample"]').value == '') errorsTxt.push('Informe seu telefone!');
    if (form.querySelector('[name="email"]').value == '') errorsTxt.push('Informe seu email!');
    if (form.querySelector('[name="cpf"]').value == '' && form.querySelector('[name="cnpj"]').value == '') errorsTxt.push('Informe seu CPF/CNPJ!');
    if (form.querySelector('[name="password"]').value == '') errorsTxt.push('Informe sua senha!');
    if (form.querySelector('[name="password"]').value != '') {
      let pass = form.querySelector('[name="password"]').value;
      let confirmationPass = form.querySelector('[name="password_confirmation"]').value;
      if (pass != confirmationPass) errorsTxt.push('Senha e confirmação são diferentes!');
    }

    if (errorsTxt.length)
      B2B.showErrors(form);

    return { validated: !errorsTxt.length, errors: errorsTxt };
  },
  validateRecover: function (form) {
    let errorsTxt = [];

    if (form.querySelector('[name="email"]').value == '') errorsTxt.push('Informe seu email!');

    if (errorsTxt.length)
      B2B.showErrors(form);

    return { validated: !errorsTxt.length, errors: errorsTxt };
  },
  validateRequest: function (form) {
    let errorsTxt = [];

    if (form.querySelector('[name="email"]').value == '') errorsTxt.push('Informe seu email!');
    if (form.querySelector('[name="message"]').value == '') errorsTxt.push('Informe sua mensagem!');

    if (errorsTxt.length)
      B2B.showErrors(form);

    return { validated: !errorsTxt.length, errors: errorsTxt };
  },

  /////////////////////////////////
  // FORMS INPUTS/BUTTONS HANDLE //
  /////////////////////////////////
  setForms: function () {
    const
      inputCPF = document.querySelector('input[name="cpf"]'),
      inputCNPJ = document.querySelector('input[name="cnpj"]'),
      inputCEP = document.querySelector('input[name="cep"]'),
      inputPhone = document.querySelector('input[name="phone_sample"]'),
      btnLogin = document.querySelector('[data-form-login] button[type="button"]'),
      btnRegister = document.querySelector('[data-form-register] button[type="button"]'),
      btnRecover = document.querySelector('[data-form-recover] button[type="button"]'),
      btnRequest = document.querySelector('[data-form-request] button[type="button"]')

    if (inputCPF) inputCPF.addEventListener('input', function (e) {
      let v = e.target.value.replace(/\D/g, '');
      v = v.replace(/^(\d{3})(\d)/, '$1.$2');
      v = v.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
      v = v.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
      e.target.value = v;
    });

    if (inputCNPJ) inputCNPJ.addEventListener('input', function (e) {
      let v = e.target.value.replace(/\D/g, '');
      v = v.replace(/^(\d{2})(\d)/, '$1.$2');
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');
      v = v.replace(/(\d{4})(\d)/, '$1-$2');  
      e.target.value = v;
    });

    if (inputCEP) inputCEP.addEventListener('input', function (e) {
      let x = e.target.value.replace(/\D/g, '').match(/(\d{0,5})(\d{0,3})/);
      e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2];
    });

    if (inputPhone) inputPhone.addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });
    
    if (btnLogin) btnLogin.addEventListener('click', (e) => {
      e.preventDefault();
      let respValidated = B2B.validateLogin(e.target.form);
      if (respValidated.validated)
        B2B.login(e.target.form);
    });

    if (btnRegister) btnRegister.addEventListener('click', (e) => {
      e.preventDefault();
      let respValidated = B2B.validateRegister(e.target.form);
      if (respValidated.validated)
        B2B.login(e.target.form);
    });

    if (btnRecover) btnRecover.addEventListener('click', (e) => {
      e.preventDefault();
      let respValidated = B2B.validateRecover(e.target.form);
      if (respValidated.validated)
        B2B.recover(e.target.form);
    });

    if (btnRequest) btnRequest.addEventListener('click', (e) => {
      e.preventDefault();
      B2B.validateRequest(e.target.form);
    });
  },

  //////////////////
  // FORMS SUBMIT //
  //////////////////
  login: function (form) {
    
    if (form.hasAttribute('data-form-register')) {
      let inputPhone = form.querySelector('input[name="phone"]');
      let inputPhoneArea = form.querySelector('input[name="phone_area"]');
      let inputPhoneSample = form.querySelector('input[name="phone_sample"]');

      if (inputPhoneSample.value.includes(')')) {
        let phone = inputPhoneSample.value.split(')')[1].replace(' ', '').replace('-', '');
        let area = inputPhoneSample.value.split(')')[0].replace('(', '');
  
        inputPhone.value = phone;
        inputPhoneArea.value = area;
      }
    }

    if (!form.classList.contains('-sending-login'))
      $.ajax({
        url: '/entrar',
        type: 
          form.hasAttribute('data-form-register') 
            ? 'POST' 
            : 'PUT',
        dataType: 'json',
        data: $(form).serialize(),
        beforeSend: function () {
          form.classList.add('-sending-login');
        }
      })
        .done(async function (resp) {
          console.log('resp', resp);
          if (resp.error) {
            B2B.showErrors(form, resp.error);
            
          } else if (resp.client) {
            if (form.hasAttribute('data-form-register')) {

              // Desabilita campos de senha antes de enviar
              let passwords = form.querySelectorAll('input[type="password"]');
              passwords.forEach(password => { password.disabled = true });

              // Envia webform antes de redirecionar
              await fetch('/webform', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: serializeArray(form)
              });
            }

            window.location.reload();
          }
        })
        .fail(function (resp) {
          console.error('error', resp);
        })
        .always(function () {
          form.classList.remove('-sending-login');
        })
  },
  recover: function (form) {
    if (!form.classList.contains('-sending'))
      $.ajax({
        url: '/recuperar_senha',
        type: 'POST',
        dataType: 'json',
        data: $(form).serialize(),
        beforeSend: function () {
          form.classList.add('-sending');
        }
      })
        .done(function (resp) {
          if (resp.error) B2B.showErrors(form, resp.error);
          if (resp.ok) B2B.showErrors(form, resp.ok);
        })
        .fail(function (resp) {
          console.error("error", resp);
        })
        .always(function () {
          form.classList.remove('-sending');
        })
  },

  //////////////////
  // FORMS ERRORS //
  //////////////////
  showErrors: function (form, error) {
    let msgReturn = form.querySelector('.msg-return');
    
    msgReturn.innerHTML = `<p>${
      error
        ? `${error}.`
        : 'Preencha todos os campos!'
    }</p>`;
    
    setTimeout(() => { msgReturn.innerHTML = '' },
      error
        ? 3000
        : 3000
    );
  },

  //////////////////////////////
  // POPUPS OPEN/CLOSE HANDLE //
  //////////////////////////////
  setPopups: function () {
    const
      popupsOpen = document.querySelectorAll('[data-b2b-access-popup-open]'),
      popupsClose = document.querySelectorAll('[data-b2b-access-popup-close]')
    if (popupsOpen.length > 0 && popupsClose.length > 0) {

      popupsOpen.forEach(open => {
        open.addEventListener('click', (e) => {
          e.preventDefault();
          let popup = document.querySelector(`[data-b2b-access-popup="${
            open.getAttribute('data-b2b-access-popup-open')
          }"]`);
          if (popup)
            popup.classList.add('-active');
        });
      });
      popupsClose.forEach(close => {
        close.addEventListener('click', () => {
          close.closest('[data-b2b-access-popup]')
            .classList.remove('-active');
        });
      });
    }
  },

  /////////////////////
  // CONTENT DISPLAY //
  /////////////////////
  displayB2B: function (client) {
    const
      contentB2B = document.querySelectorAll('[data-b2b-access], [data-b2b-access-popup]'),
      contentB2C = document.querySelectorAll(`body > div:not([data-b2b-access]):not([data-b2b-access-popup]):not(#icons)`)
    
    B2B.toggleChange();
    B2B.toggleRecover();
    B2B.setForms();
    B2B.setPopups();

    contentB2C.forEach(c => { c.remove() });
    contentB2B.forEach(c => {
      c.classList.add('-visible');

      if (client) {
        if (c.querySelector('[data-b2b-access-request]')) {
          c.querySelector('[data-b2b-access-request]')
            .classList.add('-active');
          c.querySelector('[data-b2b-access-request] input[name="email"]')
            .value = client.email;
        }
      } else {
        if (c.querySelector('[data-b2b-access-login]'))
          c.querySelector('[data-b2b-access-login]')
            .classList.add('-active');
      }
    });
  },
  displayB2C: function () {
    const
      contentB2B = document.querySelectorAll('[data-b2b-access], [data-b2b-access-popup]'),
      contentB2C = document.querySelectorAll(`body > div:not([data-b2b-access]):not([data-b2b-access-popup]):not(#icons)`)
    
    contentB2B.forEach(c => { c.remove() });
    contentB2C.forEach(c => { c.classList.add('-visible') });
  },

  init: async function () {
    let response = await fetch('/conta/cliente', {
      headers: { accept: 'application/json' }
    });

    const
      client = await response.json(),
      access = Object.keys(client).length > 0,
      { displayB2B, displayB2C } = this

    console.log('client', client);

    access
      ? client.tags && client.tags.includes('cnpj-liberado')
        ? displayB2C()
        : displayB2B(client)
      : displayB2B(false)
  },
};

export default B2B;
